import { useMutation, useQuery } from '@tanstack/react-query'
import { useAtomValue } from 'jotai'
import {
  canCreateCodeQuery,
  generateCodeMutation,
  getReferrerProfileQuery,
} from '@/src/queries/keys/referralcodes'
import { userAtom } from '@/src/stores/user/atoms'
import { linkReferralCodeMutation } from '../keys/referralcodes'

export function useCanCreateCode(code: string, enabled = true) {
  const user = useAtomValue(userAtom)

  return useQuery(
    canCreateCodeQuery(
      code,
      user.id !== 'guest' ? user.id : undefined,
      enabled && user.id !== 'guest',
    ),
  )
}

export function useGenerateReferralCode() {
  return useMutation(generateCodeMutation())
}

export function useGetReferrerProfile() {
  const user = useAtomValue(userAtom)

  return useQuery({
    ...getReferrerProfileQuery,
    enabled: user.id !== 'guest',
  })
}

export function useLinkReferralCode() {
  return useMutation(linkReferralCodeMutation())
}
